var NOTE_ATTRIBUTE = 'data-captions-menu-note';
var createNote = function (note) {
    var element = document.createElement('div');
    element.setAttribute('slot', 'header');
    element.setAttribute(NOTE_ATTRIBUTE, '');
    element.textContent = note;
    Object.assign(element.style, {
        fontSize: '0.85em',
        lineHeight: '1.3',
        maxWidth: '16em',
        opacity: '0.8',
        whiteSpace: 'normal',
    });
    return element;
};
/**
 * Shows `note` at the top of the player's captions menu, in media-chrome's menu `header` slot. The menu lives in
 * Mux's theme shadow root, which rebuilds it on layout changes (size, fullscreen), so an observer re-adds the note.
 * Reaches into Mux's markup: if that changes, this does nothing. Returns a cleanup.
 */
export var syncCaptionsMenuNote = function (player, note) {
    var _a;
    var root = (_a = player.mediaTheme) === null || _a === void 0 ? void 0 : _a.shadowRoot;
    if (!root)
        return function () { };
    var addNotes = function () {
        root.querySelectorAll('media-captions-menu').forEach(function (menu) {
            if (menu.querySelector(":scope > [".concat(NOTE_ATTRIBUTE, "]")))
                return;
            menu.append(createNote(note));
        });
    };
    addNotes();
    var observer = new MutationObserver(addNotes);
    observer.observe(root, { childList: true, subtree: true });
    return function () {
        observer.disconnect();
        root.querySelectorAll("[".concat(NOTE_ATTRIBUTE, "]")).forEach(function (element) { return element.remove(); });
    };
};
